<template>
  <div id="userAll">
    <div class="classify">
      <div class="left">
        <span class="status">状态：</span>
        <span
          @click="setStatusAct(0, null)"
          :class="statusAct === 0 ? 'act' : 'statusList'"
          >全部</span
        >
        <span
          @click="setStatusAct(1, 1)"
          :class="statusAct === 1 ? 'act' : 'statusList'"
          >已发布</span
        >
        <span
          @click="setStatusAct(2, 2)"
          :class="statusAct === 2 ? 'act' : 'statusList'"
          >审核中</span
        >
        <span
          @click="setStatusAct(3, 3)"
          :class="statusAct === 3 ? 'act' : 'statusList'"
          >未通过</span
        >
        <span
          @click="setStatusAct(4, 4)"
          :class="statusAct === 4 ? 'act' : 'statusList'"
          >已下架</span
        >
        <span
          @click="setStatusAct(5, 5)"
          :class="statusAct === 5 ? 'act' : 'statusList'"
          >草稿</span
        >
      </div>
      <div class="right">
        <span class="time">时间：</span>
        <DatePicker
          v-model="dateArr"
          format="yyyy-MM-dd"
          @on-change="handleChange"
          type="daterange"
          placement="bottom-end"
          placeholder="Select date"
          style="width: 220px"
        ></DatePicker>
        <Input
          v-model="search"
          placeholder="请输入标题进行搜索"
          class="searchinput"
        >
          <Icon @click="handleClick" type="ios-search" slot="suffix" />
        </Input>
        <input type="text" style="opacity: 0; width: 0" />
      </div>
    </div>
    <div class="list">
      <div class="box" v-for="item in list" :key="item.meetingId">
        <div class="listImg">
          <img class="img" :src="$global.imgUrl + item.cover" />
        </div>
        <div class="left">
          <div class="msg">
            <div class="top" v-if="item.status !== 2">
              <span style="font-size: 14px;" :class="item.auditStatus | colored">{{
                item.auditStatus | type
              }}</span>
              <span style="font-size: 14px;"></span>
              <span v-html="item.title"></span>
            </div>
            <div class="top" v-else>
              <span class="down">已下架</span>
              <span></span>
              {{ item.title }}
            </div>
            <div class="introduce">
              <div class="introduce-box">
                <Icon type="ios-time-outline" class="icon-img" />
                <span class="title"> 时间：</span>
                <span>{{ item.beginTime.slice(0, 10) }}</span>
              </div>
              <div class="introduce-box" style="flex: 1">
                <Icon type="ios-pin-outline" class="icon-img" />
                <span class="title"> 地点：</span>
                <span>{{ item.province }}</span>
                <span>{{ item.city }}</span>
                <span>{{ item.address }}</span>
              </div>
            </div>
            <template>
              <div v-if="item.auditStatus === 2" class="read">
                <span class="key">
                  阅读量：<span class="value">{{ item.readNum }}</span>
                </span>
                <span class="key">
                  收藏量：<span class="value">{{ item.collectNum }}</span>
                </span>
              </div>
              <div v-if="item.auditStatus === 3">
                <span>原因：</span>
                <span>{{
                  item.failureReason === "null" ? "" : item.failureReason
                }}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="right">
          <div class="passTime">
            {{ item.createTime }}
          </div>
          <div class="edit" v-if="item.status !== 2">
            <template v-if="item.auditStatus === 0">
              <span class="black">修改</span>
              <span class="black">删除</span>
            </template>
            <template v-if="item.auditStatus === 3">
              <span class="blue" @click="edit(item.meetingId)">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.auditStatus === 1">
              <span class="blue" @click="edit(item.meetingId)">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.auditStatus === 2">
              <div style="display: flex">
                <Upload
                  :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
                  :headers="{ token: token }"
                  multiple
                  :show-upload-list="false"
                  accept=".png,.jpg,.jpeg"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="1024"
                  :on-exceeded-size="handleMaxSize"
                  :on-success="
                    (res, file) => {
                      openUpload(res, file, item.meetingId);
                    }
                  "
                >
                  <span class="blue">上传图片</span>
                </Upload>
                <Upload
                  action=""
                  :headers="{ token: token }"
                  accept=".mp4,.avi"
                  :format="['mp4', 'avi']"
                  :show-upload-list="false"
                  :max-size="512000"
                  :before-upload="
                    (file) => {
                      openVModel(file, item.meetingId);
                      return false;
                    }
                  "
                  :on-exceeded-size="handleMaxSize"
                >
                  <span class="blue">上传视频</span>
                </Upload>
                <span class="blue" @click="openDrawer(item.meetingId)"
                  >详细信息</span
                >
                <span class="black">修改</span>
                <!-- <span class="blue">下架</span> -->
                <span class="black">删除</span>
              </div>
            </template>
          </div>
          <div class="edit" v-else>
            <span class="black">修改</span
            ><span class="blue" @click="del(item)">删除</span>
          </div>
        </div>
      </div>
      <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
    <Drawer :mask-closable="false" width="60" v-model="detailsShow">
      <DrawerDetail v-if="detailsShow" :id="meetingId" />
    </Drawer>
    <!-- 上传图片弹窗 -->
    <Modal
      width="572"
      v-model="IUploadShow"
      footer-hide
      :mask-closable="false"
      @on-visible-change="modalChange"
    >
      <h3>会议图片</h3>
      <div class="img-upload-box">
        <div
          class="img-upload-list"
          v-for="item in uploadImgList"
          :key="item.id"
        >
          <img class="img" :src="$global.imgUrl + item.url" alt="" />
          <Input v-model="item.name" size="small" />
          <Icon
            class="img-upload-icon"
            type="ios-close-circle"
            size="16"
            @click="uploadImgClose(item.id)"
          />
        </div>
        <Upload
          :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
          :headers="{ token: token }"
          multiple
          :show-upload-list="false"
          accept=".png,.jpg,.jpeg"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="1024"
          :on-exceeded-size="handleMaxSize"
          :on-success="
            (res, file) => {
              openUpload(res, file, meetingId);
            }
          "
        >
          <div class="img-upload-item">
            <Icon type="ios-add" size="50" />
            <p class="text">请上传会议图片</p>
          </div>
        </Upload>
      </div>
      <div style="text-align: center">
        <Button
          type="primary"
          size="large"
          style="padding: 0 50px"
          @click="submitImg"
          >提交</Button
        >
      </div>
    </Modal>
    <!-- 上传视频弹窗 -->
    <Modal
      width="572"
      v-model="VUploadShow"
      footer-hide
      :mask-closable="false"
      @on-visible-change="modalChange"
    >
      <h3>会议视频</h3>
      <div class="progress-box">
        <div
          class="progress"
          style="display: flex; align-items: center"
          v-if="progressTotal > 0 && progressTotal < 100"
        >
          <Icon style="margin-right: 10px" type="ios-videocam" size="40" />
          <Progress
            style="flex: 1"
            v-if="progressTotal > 0 && progressTotal < 100"
            :percent="progressTotal"
            :stroke-width="8"
          />
          <span
            style="cursor: pointer"
            type="primary"
            v-if="progressTotal > 0 && progressTotal < 99"
            @click="handleBtn"
            >{{ btn | btnText }}</span
          >
        </div>
        <div style="display: flex; align-items: center;">
          <span class="progress-title">标题：</span>
          <Input style="flex: 1" v-model="fileName" size="small" />
        </div>
      </div>
      <div style="text-align: center">
        <Button
          type="primary"
          size="large"
          style="padding: 0 50px"
          :disabled="progressTotal < 100"
          @click="submitVideo"
          >提交</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mixin from "@/mixins/continuingly";
import Paging from "@/components/paging/index.vue";
import DrawerDetail from "./drawerDetail.vue";

export default {
  name: "all",
  computed: {
    ...mapState(["token"]),
  },
  mixins: [mixin],
  components: { Paging, DrawerDetail },
  data() {
    return {
      dateArr: [null, null],
      search: null,
      status: null,
      statusAct: 0,
      spinShow: false,
      list: [],
      page: 1,
      total: 0,
      detailsShow: false,
      IUploadShow: false,
      VUploadShow: false,
      uploadImgList: [],
      meetingId: "",
    };
  },
  filters: {
    type: function (num) {
      if (num === 2) {
        return "已发布";
      } else if (num === 0) {
        return "审核中";
      } else if (num === 3) {
        return "未通过";
      } else if (num === 1) {
        return "草稿";
      }
    },
    colored: function (num) {
      if (num === 2) {
        return "send";
      } else if (num === 0) {
        return "ing";
      } else if (num === 3) {
        return "pass";
      } else if (num === 1) {
        return "edit";
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    modalChange(type) {
      if (!type) {
        this.uploadImgList = [];
        this.meetingId = "";
        this.url = "";
        this.progressTotal = 0;
        this.fileName = "";
      }
    },
    uploadImgClose(id) {
      this.uploadImgList = this.uploadImgList.filter((item) => item.id !== id);
    },
    // 提交图片
    async submitImg() {
      const res = await this.$apis.userServe.addMeetingVideoImg({
        meetingId: this.meetingId,
        type: 1,
        dtos: this.uploadImgList,
      });
      if (res.resultCode === "200") {
        this.IUploadShow = false;
        this.meetingId = "";
        this.uploadImgList = [];
      }
    },
    // 提交视频
    async submitVideo() {
      const res = await this.$apis.userServe.addMeetingVideoImg({
        meetingId: this.meetingId,
        type: 2,
        dtos: [
          {
            url: this.url,
            name: this.fileName,
          },
        ],
      });
      if (res.resultCode === "200") {
        this.VUploadShow = false;
        this.meetingId = "";

        this.url = "";
        this.progressTotal = 0;
        this.fileName = "";
      }
    },
    openVModel(file, id) {
      this.VUploadShow = true;
      this.meetingId = id;
      this.handleBefore(file)
        .then((res) => {})
        .catch((err) => {}); // catch 接受下handleBefore方法返回的promise报错
    },
    // 图片上传超过限制大小
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片/视频上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
    // 图片上传
    openUpload(res, file, id) {
      this.IUploadShow = true;
      this.meetingId = id;
      this.uploadImgList.push({
        id: file.uid,
        url: file.response.content.url,
        name: file.name,
      });
    },
    // 打开详细信息抽屉
    openDrawer(id) {
      this.detailsShow = true;
      this.meetingId = id;
    },
    // 修改进入发布页面
    edit(meetingId) {
      this.$router.push(`/conferenceForm?id=${meetingId}&title=会议`);
    },
    // 删除
    async del(e) {
      this.$Modal.confirm({
        title: "操作确认",
        content: `<p>是否删除<${e.title}>?删除后无法恢复</p>`,
        onOk: async () => {
          const res = await this.$apis.userServe.delmeetingById({
            id: e.meetingId,
          });
          if (res.resultCode === "200") {
            this.$Message.success("删除成功");
            this.getList();
          } else {
            this.$Message.error("删除失败");
          }
        },
        onCancel: () => {
          this.$Message.info("已取消删除操作");
        },
      });
    },
    // 分页
    handlePager(e) {
      this.page = e;
      this.getList();
    },
    // 标题搜索
    handleClick() {
      this.page = 1;
      this.getList();
    },
    // 日期筛选
    handleChange(value) {
      console.log(value);
      this.dateArr = value;
      this.page = 1;
      this.getList();
    },
    // 筛选状态
    setStatusAct(i, status) {
      this.statusAct = i;
      this.status = status;
      this.page = 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.spinShow = true;
      const { data } = await this.$apis.userServe.getUserCenterPage({
        pageNo: this.page,
        pageSize: 10,
        status: this.status,
        title: this.search,
        beginTime: this.dateArr[0],
        endTime: this.dateArr[1],
      });
      this.spinShow = false;
      let { total } = data;
      this.total = Number(total);
      this.list = data.list;
    },
  },
};
</script>

<style lang="scss" scoped>
#userAll {
  padding-top: 30px;
  //background: yellow;
  width: 1200px;
  //height: 300px;
  .list {
    position: relative;
    margin-top: 30px;
    min-height: 500px;

    .demo-spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
    }

    .box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px 45px;
      min-height: 160px;
      background: #fff;

      .listImg {
        margin-right: 25px;
        width: 120px;
        height: 118px;
        background: rgb(244, 244, 244);
        .img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 10px;
        text-align: right;
        .time {
          font-size: 12px;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #666666;
          text-align: right;
        }

        .edit {
          text-align: right;
          span {
            margin-left: 25px;
            cursor: pointer;
          }
          span:nth-child(2) {
            width: 140px !important;
          }

          .title {
            margin-bottom: 20px;
            font-size: 14px;
            width: 100px;
            //font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 24px;
            color: #333333;
            cursor: pointer;

            .blue {
              //height: 24px;
              font-size: 12px;
              line-height: 24px;
              //font-family: Microsoft YaHei;
              font-weight: 400;
              color: #183ed7;
            }

            .black {
              //height: 13px;
              font-size: 12px;
              line-height: 24px;
              //font-family: Microsoft YaHei;
              font-weight: 400;
              color: #999999;
            }
          }

          .blue {
            color: rgba(11, 53, 197, 1);
          }

          .black {
            color: #999999;
          }
        }
      }

      .left {
        overflow: hidden;
        display: flex;
        flex: 1;

        img {
          width: 122px;
          height: 122px;
        }

        .msg {
          display: flex;
          flex-direction: column;
          width: 100%;
          font-size: 14px;
          .top {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 18px;
            .edit {
              color: #ff9415;
              margin-right: 10px;
            }
            .edit + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #ff9415;
              display: inline-block;
            }

            .send {
              color: #10286f;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .send + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #10286f;
              display: inline-block;
            }

            .ing {
              color: #8073d2;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .ing + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #8073d2;
              display: inline-block;
            }

            .pass {
              color: #ff0000;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .pass + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #ff0000;
              display: inline-block;
            }

            .down {
              color: #dc727c;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .down + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #dc727c;
              display: inline-block;
            }
          }
          .introduce {
            display: flex;
            margin: 24px 0;
            .introduce-box {
              &:first-child {
                margin-right: 30px;
                width: 200px;
              }
              .icon-img {
                font-size: 19px;
                color: #193092;
                font-weight: 700;
                vertical-align: middle;
              }
              span {
                vertical-align: middle;
                word-break: break-all;
              }
              .title {
                color: #193092;
              }
            }
          }

          .read {
            width: 100%;
            .key {
              word-break: break-all;
              margin-right: 25px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
            }
          }
        }
      }
    }
  }

  .classify {
    display: flex;
    height: 30px;
    justify-content: space-between;
    width: 100%;

    .right {
      height: 30px;

      .time {
        //background: yellow;
        line-height: 30px;
        margin-right: 10px;
      }

      .searchinput {
        width: 351px;
        //height: 41px;
        border-radius: 10px;
        margin-left: 33px;
      }
    }

    .left {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      cursor: pointer;

      .status {
        margin-right: 3px;
      }

      .statusList {
        margin-left: 10px;
        margin-right: 10px;
      }

      .act {
        margin-left: 10px;
        margin-right: 10px;
        color: #0101f3;
      }
    }
  }
}
.img-upload-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  .img-upload-list {
    position: relative;
    margin: 0 10px 20px;
    width: 160px;
    .img {
      width: 100%;
      height: 160px;
      border: 1px solid #999;
      border-radius: 5px;
    }
    .img-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .img-upload-icon {
      position: absolute;
      top: -8px;
      right: -8px;
      cursor: pointer;
    }
  }
  .img-upload-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 10px;
    width: 160px;
    height: 160px;
    color: #1989fa;
    text-align: center;
    border: 1px dashed #e4e4e4;
    border-radius: 5px;
    .plus {
      font-size: 50px;
    }
  }
}
.progress-box {
  margin: 20px 0;
  .progress {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #d7d7d7;
    border-radius: 5px;
  }
  .progress-title {
    font-size: 18px;
  }
}
::v-deep .ivu-drawer-close {
  top: 0;
  right: 0;
  left: 0;
  width: 36px;
  height: 36px;
  border-radius: 0 0 36px 0;
  background-color: rgba(55, 55, 55, 0.6);
  .ivu-icon-ios-close {
    top: -2px;
    left: -2px;
    font-size: 34px;
    color: #fff;
  }
}
</style>
